import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import withStyles from '@mui/styles/withStyles';
import PageTitle from '../ui/PageTitle';
import { Grid, Paper } from '@mui/material';

import ServerError from '../ui/ServerError';
import AbEnvironment from '../auth/AbEnvironment';

import Form from './Form';
import LoadingSpinner from '../ui/LoadingSpinner';

const styleSheet = theme => ({
  root: {
    width: '100%',
  },
  rootLoggedIn: {
    flexGrow: 1,
    //padding: 20,
  },
  paper: {
    textAlign: 'left',
    //color: theme.palette.text.secondary,
    maxWidth: 980,
    marginTop: 32,
    marginBottom: 0,
    paddingTop: 16,
    paddingLeft: 20,
    paddingRight: 20,
    paddingBottom: 20,
  }
});

const abEnvironment = new AbEnvironment();

const FormPreviewQuery = graphql`
query FormPreviewQuery($formId: UUID!) {
  formTByFormId(formId: $formId) {
    formName
    formTitle
    formSubtitle
    description
    formDetailTsByFormId (orderBy: Q_ORDER_ASC) {
      totalCount
      nodes {
        key: qKey
        name: qName
        type: qType
        default: qDefault
        optional: qOptional
        qWidth
        formDetailValuesTsByFormDetailId (orderBy: DISPLAY_ORDER_ASC) {
          totalCount
          values: nodes {
            value: displayOrder
            text 
          }
        }
      }
    }
  }
}
`;

class FormPreview extends Component {

  constructor(props) {
    super(props);

    this.state = {
      saveStatus: null,
      saveFormMessage: '',
      fieldErrors: {},
      values: null,
    }
  }

  //lift "values" state here from the form.
  handleChange(values) {
    this.setState({
      values: values
    });
    // console.log('formstate: ' + JSON.stringify(values) + '\ntopstate: ' + JSON.stringify(this.state.values) + '\nlastsaved: ' + this.state.valuesLastSaved);
  }

  render() {
    const classes = this.props.classes;
    const { isAuthenticated, needAssent, isAuthenticatedVendor, logError, isAuthenticatedAppBind } = this.props.auth;

    if (!isAuthenticated() || needAssent()) {
      return (<Redirect to='/home' />);
    } else if (isAuthenticatedVendor() || isAuthenticatedAppBind()) {

      let componentView = false;
      let formId;
      if (this.props.formId) {
        //if this is a props view, load the values that way instead.
        formId = this.props.formId
        componentView = true;
      } else {
        //grab parameters for use in query renderer...
        const params = new URLSearchParams(this.props.location.search);
        formId = params.get('formId');
      }
      
      //using query renderer within the return segment...
      if (!formId) {
        return (<Redirect to='/home' />);
      }

      return (
        <div classes={classes.rootLoggedIn}>
          <QueryRenderer
            environment={abEnvironment.getEnvironment()}
            query={FormPreviewQuery}
            variables={{
              formId: formId,
            }}
            render={({error, props})=> {
              if (error) {
                
                logError(JSON.stringify(error));
                return (
                  <ServerError />
                );
              } else if (props) {
                // if nothing is returned, then there's no access right OR the form doesn't exist
                if (props.formTByFormId === null) {
                  return (
                    <PageTitle title={"Form not found"} showBackButton={true} history={this.props.history}/>
                  );
                }

                let form = props.formTByFormId;

                let fieldsFromDB = form.formDetailTsByFormId.nodes;
                
                let values = {};
                //add the default values from each field here if no form response entries.
                for (let i = 0; i < fieldsFromDB.length; i++) {
                  let currentField = fieldsFromDB[i];
                  if (currentField.default) {
                    values[currentField.key] = currentField.default
                  }
                }

                // Get the form title and subtitle
                let formTitle = form.formTitle;
                let formSubtitle = form.formSubtitle;

                //the form
                let theFormRender = <Form
                                      onChange={(values) => {this.handleChange(values)}}
                                      values={this.state.values || values}
                                      fields={fieldsFromDB}
                                      saveStatus={this.state.saveStatus}
                                      saveFormMessage={this.state.saveFormMessage}
                                      snackbarClose={() => { this.setState({ saveStatus: '', saveFormMessage: '' }); }}
                                      preview={true}
                                      errors={this.state.fieldErrors}
                                    />;

                return (
                  <Grid container spacing={1}>
                    { !componentView &&
                      <Grid item xs={12}>
                        <PageTitle title={formTitle} subtitle={formSubtitle} />
                        <Paper className={classes.paper}>
                          { theFormRender }
                        </Paper>
                      </Grid>
                    }
                    { componentView &&
                      <Grid item xs={12}>
                        <PageTitle title={formTitle} subtitle={formSubtitle} />
                        { theFormRender }
                      </Grid>
                    }
                  </Grid>
                )
              }
              return <LoadingSpinner />
            }}
          />
          
        </div>
      );
    } else {
      return (<Redirect to='/home' />);
    }
  }

}

export default withStyles(styleSheet)(FormPreview);